// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ecc13549","438":"b7c546ed","504":"96c8bf8f","584":"0e3b74f3","746":"dfcee7cd","802":"7a49aa10"}[chunkId] + ".chunk.js";
};